import clsx from "clsx";
import type { PropsWithChildren, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";

type MainLayoutProps = PropsWithChildren<{ navbar?: ReactNode }>;

const MainLayout = ({ children, navbar }: MainLayoutProps) => {
  const { pathname } = useLocation();
  const isGalleryPage = pathname === "/gallery";
  const isViewPage = pathname.startsWith("/view/");

  // Gallery and About run past the viewport, so they scroll. Previously
  // /about got both `overflow-hidden` and `overflow-y-auto`, leaving the
  // winner up to stylesheet order.
  const isScrollable = isGalleryPage || pathname === "/about";

  return (
    <div className="w-full h-screen flex flex-grow justify-stretch flex-col items-center lg:p-10">
      {navbar}
      <main
        className={clsx("w-full h-full relative bg-grey-600 text-white", {
          "overflow-hidden": !isScrollable,
          "overflow-y-auto": isScrollable,
        })}
      >
        {children}
      </main>
      {/* Gallery renders its own footer inside the scroll area. */}
      {!(isGalleryPage || isViewPage) && <Footer />}
    </div>
  );
};

export default MainLayout;
